/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Liability_Links_TitleInputs */

const en_impressum_liability_links_title = /** @type {(inputs: Impressum_Liability_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liability for Links`)
};

const de_impressum_liability_links_title = /** @type {(inputs: Impressum_Liability_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haftung fuer Links`)
};

const fr_impressum_liability_links_title = /** @type {(inputs: Impressum_Liability_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabilité pour les liens`)
};

const es_impressum_liability_links_title = /** @type {(inputs: Impressum_Liability_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabilidad por los enlaces`)
};

const it_impressum_liability_links_title = /** @type {(inputs: Impressum_Liability_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabilità per i link`)
};

const nl_impressum_liability_links_title = /** @type {(inputs: Impressum_Liability_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aansprakelijkheid voor links`)
};

const pl_impressum_liability_links_title = /** @type {(inputs: Impressum_Liability_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpowiedzialność za linki`)
};

const fi_impressum_liability_links_title = /** @type {(inputs: Impressum_Liability_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vastuu linkeistä`)
};

const da_impressum_liability_links_title = /** @type {(inputs: Impressum_Liability_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansvar for links`)
};

const sv_impressum_liability_links_title = /** @type {(inputs: Impressum_Liability_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansvar för länkar`)
};

/**
* | output |
* | --- |
* | "Liability for Links" |
*
* @param {Impressum_Liability_Links_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_liability_links_title = /** @type {((inputs?: Impressum_Liability_Links_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Liability_Links_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_liability_links_title(inputs)
	if (locale === "fr") return fr_impressum_liability_links_title(inputs)
	if (locale === "es") return es_impressum_liability_links_title(inputs)
	if (locale === "it") return it_impressum_liability_links_title(inputs)
	if (locale === "nl") return nl_impressum_liability_links_title(inputs)
	if (locale === "pl") return pl_impressum_liability_links_title(inputs)
	if (locale === "fi") return fi_impressum_liability_links_title(inputs)
	if (locale === "da") return da_impressum_liability_links_title(inputs)
	if (locale === "sv") return sv_impressum_liability_links_title(inputs)
	return en_impressum_liability_links_title(inputs)
});